export default "__VITE_ASSET__QAm4Mviz__"